import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Header = styled.div`
  padding: ${props => props.theme.spacing.sp8} 0;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.text.subtle};
`

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
`
